<template lang="html">
  <div class="section-list-container">
    <h3 v-show="multipleSections" class="title-section article-list-headers-font">{{ section.name }}</h3>
    <ul class="section-list">
      <cci-article-list-item v-for="article in sectionArticles" :article="article" :index="filteredArticles.indexOf(article)" :key="article.id" :id="'article-list-' + filteredArticles.indexOf(article)"></cci-article-list-item>
    </ul>
  </div>
</template>

<script>
import CciArticleListItem from './CciArticleListItem.vue'
import { mapGetters } from 'vuex'

export default {
  props: ['section'],
  data () {
    return {}
  },
  mounted () {
    this.applySettings(this.settings)
  },
  computed: {
    sectionArticles: function () {
      return this.section.articles.filter(function (article) {
        return article.attributes.JumpOriginArticleId === undefined && article.attributes.TeaserText !== ''
      })
    },
    multipleSections () {
      return this.sections.length > 1
    },
    filteredArticles: function () {
      return this.articles.filter(function (article) {
        return article.attributes.JumpOriginArticleId === undefined && article.attributes.TeaserText !== ''
      })
    },
    ...mapGetters({
      settings: 'getSettings',
      sections: 'getSections',
      articles: 'getArticles'
    })
  },
  watch: {
    settings: function (newValue) {
      this.applySettings(newValue)
    }
  },
  methods: {
    applySettings (settings) {
      if (settings !== undefined) {
        var sectionElem = document.getElementsByClassName('title-section')
        for (var i = 0; i < sectionElem.length; i++) {
          sectionElem[i].style.color = settings.articleListHeadlinesColor
          sectionElem[i].style.backgroundColor = settings.articleListBackgroundColor
        }
      }
    }
  },
  components: {
    CciArticleListItem
  }
}
</script>

<style lang=scss>
@import 'helpers/_colors-and-mixins.scss';
@import 'bourbon';

.title-section{
  margin-top: 30px;
  margin-bottom: 0px;
  font-size: em(18px);
  font-weight: 600;
  border-bottom: 1px solid $silver;
  top: 0;
  position: sticky;
  position: -moz-sticky;
  position: -ms-sticky;
  position: -o-sticky;
  position: -webkit-sticky;
  background-color: white;
}

.section-list{
  padding-left: 0px;
  margin: 0;
  list-style: none;
}
</style>
